'use client';

import { useCallback } from 'react';
import { Box } from '@terra/ui-styled-system';
import { ToolCallHttpViewerDialog } from '@terra/ui-design-system';
import { useMainContentTabs } from '../../store/layoutStore';
import type { Tab } from '../../store/layoutStore';

type HttpViewerTabProps = {
  tab: Tab;
};

export function HttpViewerTab({ tab }: HttpViewerTabProps) {
  const { closeTab } = useMainContentTabs();

  const tabData = tab.data as {
    request: {
      method: string;
      url: string;
      headers: Record<string, string | string[]>;
      body?: string;
      httpVersion?: string;
    } | null;
    response: {
      status?: number;
      statusMessage?: string;
      headers?: Record<string, string | string[]>;
      body?: string;
      httpVersion?: string;
    } | null;
    fallbackOutput?: unknown;
    toolName?: string;
    title?: string;
  };

  const handleClose = useCallback(
    (open: boolean) => {
      if (!open) {
        closeTab(tab.id);
      }
    },
    [closeTab, tab.id],
  );

  return (
    <Box h="full" w="full" overflow="hidden">
      <ToolCallHttpViewerDialog
        isOpen
        onOpenChange={handleClose}
        request={tabData.request}
        response={tabData.response}
        fallbackOutput={tabData.fallbackOutput}
        toolName={tabData.toolName}
        title={tabData.title}
        renderMode="inline"
      />
    </Box>
  );
}
